import { render } from "./PageLayout.vue?vue&type=template&id=d42096ca"
import script from "./PageLayout.vue?vue&type=script&lang=js"
export * from "./PageLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Demo/PageLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d42096ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d42096ca', __exports__)) {
    api.reload('d42096ca', __exports__)
  }
  
  module.hot.accept("./PageLayout.vue?vue&type=template&id=d42096ca", () => {
    api.rerender('d42096ca', render)
  })

}


export default __exports__